@if (filteredItems().length > 0) {
    @let pageTitle = title();
    @let labelVariant = variant();

    <div *transloco="let t; prefix: 'uiResultFilter'">
        @if (pageTitle) {
            <h2
                class="mb-4"
                [class.text-white]="labelVariant === 'dark'"
                [class.text-primary-500]="labelVariant === 'light'"
                [class.sr-only]="hideTitle()">
                {{ pageTitle }}
            </h2>
        }

        <div class="grid grid-cols-12 gap-y-8 lg:gap-0">
            <div
                #buttonWrapper
                [style.height]="!showAllFilters() && canToggleFiltersList() ? buttonWrapperHeight() + 'px' : 'auto'"
                class="order-2 col-span-12 -m-1 flex flex-wrap gap-1 overflow-hidden lg:order-1 lg:justify-start"
                [class]="{
                    'lg:col-span-10': hasOverflow() || (showAllFilters() && canToggleFiltersList()),
                    'lg:col-span-12': !(hasOverflow() || showAllFilters()),
                }">
                <div
                    #buttonReference
                    class="p-1">
                    <big-ui-result-filter-label
                        (buttonClick)="clearFilters()"
                        [variant]="labelVariant"
                        [isActive]="(filteredItems() | isActive).length === 0"
                        [ariaLabel]="pageTitle ? pageTitle + ': ' + t('all') : t('all')">
                        {{ t('all') }}
                    </big-ui-result-filter-label>
                </div>
                @for (item of filteredItems(); track item.title) {
                    <div class="p-1">
                        <big-ui-result-filter-label
                            (buttonClick)="toggleFilter(item)"
                            [variant]="labelVariant"
                            [isActive]="item.isActive"
                            [ariaLabel]="pageTitle ? pageTitle + ': ' + item.title : item.title">
                            {{ item.title }} {{ item.distribution ? '(' + item.distribution + ')' : '' }}
                        </big-ui-result-filter-label>
                    </div>
                }
            </div>
            @if (canToggleFiltersList() && (hasOverflow() || showAllFilters())) {
                <div
                    class="col-span-12 text-center lg:col-span-2 lg:justify-self-end"
                    [class.order-1]="showAllFilters()"
                    [class.order-2]="!showAllFilters()">
                    <big-ui-button
                        (click)="toggleFiltersList()"
                        [tabindex]="-1"
                        [buttonStyle]="'tertiary text-current'"
                        [class]="{
                            'text-body': labelVariant === 'light',
                            'active:text-body': labelVariant === 'light',
                            'text-white': labelVariant === 'dark',
                            'active:text-white': labelVariant === 'dark',
                        }">
                        <big-icon
                            [icon]="iconAngleDown"
                            [size]="'w-4'"
                            [inline]="true"
                            class="fill-current"
                            [class.rotate-180]="showAllFilters()" />
                        <span>
                            {{ t(showAllFilters() ? 'showLess' : 'showMore') }}
                        </span>
                    </big-ui-button>
                </div>
            }
        </div>
    </div>
}
